<template>
  <div>
    <el-checkbox
      :indeterminate="isIndeterminate"
      v-model="checkAll" for-test="checkAll"
      @change="changeCheckedAll"
    >全选</el-checkbox>
    <div class="split"></div>
    <el-checkbox-group v-model="checkList" for-test="checkList" @change="changeChecked">
      <el-checkbox v-for="item in list" :label="item[label]" :key="item[label]">{{item[name]}}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>
<style lang="scss" scoped>
  .split{
    margin:$margin-small 0;
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/check-all/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/check-all/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/check-all/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-check-all')
  export default {
    name: 'base-check-all', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-check-all': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>